import * as React from "react";
import { Dialog } from "@/components/ui";
import { ImpersonationSwitchDialogProvider, useImpersonationDialogContext } from "./ImpersonationContext";
import { TransitionScreen } from "./components/TransitionScreen";
import { Header } from "./components/Header";
import { SearchBar } from "./components/SearchBar";
import { UserList } from "./components/UserList";
import { Footer } from "./components/Footer";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ImpersonationSwitchDialogContent: React.FC = () => {
  const { transitioningUser, isReverting } = useImpersonationDialogContext();

  return (
    <Dialog.Content className="p-0 overflow-hidden flex flex-col h-full bg-white rounded-2xl shadow-2xl border border-slate-200/50 animate-in fade-in zoom-in-95 duration-200">
      {transitioningUser || isReverting ? (
        <TransitionScreen />
      ) : (
        <>
          <Header />
          <SearchBar />
          <UserList />
          <Footer />
        </>
      )}
    </Dialog.Content>
  );
};

export const ImpersonationSwitchDialog: React.FC<Props> = ({ open, onOpenChange }) => {
  return (
    <ImpersonationSwitchDialogProvider open={open} onOpenChange={onOpenChange}>
      <Dialog open={open} onOpenChange={onOpenChange} size="md" className="h-[520px]">
        <ImpersonationSwitchDialogContent />
      </Dialog>
    </ImpersonationSwitchDialogProvider>
  );
};
